import { render, staticRenderFns } from "./PriceGroups.template.vue?vue&type=template&id=ab438d48&scoped=true&"
var script = {}
import style0 from "./PriceGroups.template.vue?vue&type=style&index=0&id=ab438d48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab438d48",
  null
  
)

export default component.exports